import { commonWordNames } from "./commonwordnames";
import { usCities } from "./uscities";
import { usStates, usStateAbbrevs } from "./usstates";
import { wellKnownNames } from "./wellknownnames";
import { excludedDigits } from "./excludedDigits";

export const builtInRedactorList = {
  names: {
    enabled: false,
  },
  password: {
    enabled: false,
  },
  phoneNumber: {
    enabled: false,
  },
  username: {
    enabled: false,
  },
  digits: {
    enabled: false,
  },
};

export const customRedactorList = {
  before: [
    {
      regexpPattern: /\b\d{1,2}[.\-/]\d{1,2}[.\-/]\d{2,4}/gm,
      replaceWith: "DATE",
    },
    {
      regexpPattern:
        /(\(?\+?[0-9]{1,2}\)?[-. ]?)?(\(?[0-9]{3}\)?|[0-9]{3})[-. ]?([0-9]{3}[-. ]{1}[0-9]{4}|\b[A-Z0-9]{7}\b)/gm,
      replaceWith: "PHONE_NUMBER",
    },
  ],
  after: [
    { regexpPattern: /(?:\w{2,} )(trust)\b/gim, replaceWith: "TRUST_NAME" },
    { regexpPattern: /\w{3}\d{4,}\b/gim, replaceWith: "PLAN_ID" },
    {
      regexpPattern:
        /((user|account|acount|u\/n|un|uname)(\s?name)?|login)(\s?:(\s|)|\s? is (\s|))\S+/gim,
      replaceWith: "USERNAME",
    },
    {
      regexpPattern:
        /((pass|pas|pw|p\/w|p)(word|wrd|phrase)?|secret)(\s?:(\s|)|\s? is (\s|))\S+/gim,
      replaceWith: "PASSWORD",
    },
  ],
};

export const commonwWordNameRegex = new RegExp(
  `\\b(\\s*)(\\s*(${commonWordNames.join("|")}))\\b`,
  "gm"
);

export const customDigitsRegex = new RegExp(
  `\\b((?!${excludedDigits.join("|")})\\d{4,})\\b`,
  "gm"
);

export const nameRegex = new RegExp(
  `\\b(\\s*)(\\s*(${wellKnownNames.join("|")}))\\b`,
  "gim"
);

export const usCityRegex = new RegExp(
  `\\b(\\s*)(\\s*(${usCities.join("|")}))+\\b\\.?`,
  "gim"
);

export const usStateAbbrevsRegex = new RegExp(
  `\\b(\\s*)((\\s*(?<!-)(?!CT-)(${usStateAbbrevs.join("|")})))+\\b\\.?`,
  "gm"
);

export const usStateRegex = new RegExp(
  `\\b(\\s*)(\\s*(${usStates.join("|")}))+\\b\\.?`,
  "gim"
);
